/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './search-box.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../@angular/material/typings/index.ngfactory';
import * as i3 from '@angular/material';
import * as i4 from '@covalent/core/search/search-box/search-box.component';
import * as i5 from '@angular/common';
import * as i6 from '../search-input/search-input.component.ngfactory';
import * as i7 from '@covalent/core/search/search-input/search-input.component';
const styles_TdSearchBoxComponent:any[] = [i0.styles];
export const RenderType_TdSearchBoxComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TdSearchBoxComponent,data:{'animation':[{type:7,name:'inputState',
        definitions:[{type:0,name:'0',styles:{type:6,styles:{width:'0%',margin:'0px'},
            offset:(null as any)},options:(undefined as any)},{type:0,name:'1',styles:{type:6,
            styles:{width:'100%',margin:'*'},offset:(null as any)},options:(undefined as any)},
            {type:1,expr:'0 => 1',animation:{type:4,styles:(null as any),timings:'200ms ease-in'},
                options:(null as any)},{type:1,expr:'1 => 0',animation:{type:4,styles:(null as any),
                timings:'200ms ease-out'},options:(null as any)}],options:{}}]}});
function View_TdSearchBoxComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-icon',[['role',
      'img']],[[2,'mat-icon',(null as any)]],(null as any),(null as any),i2.View_MdIcon_0,
      i2.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,[[2,
      i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(9027584,(null as any),0,i3.MdIcon,[i1.ElementRef,i1.Renderer2,i3.MdIconRegistry],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['','']))],(_ck,_v) => {
    _ck(_v,2,0);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = _co.backIcon;
    _ck(_v,3,0,currVal_1);
  });
}
function View_TdSearchBoxComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-icon',[['role',
      'img']],[[2,'mat-icon',(null as any)]],(null as any),(null as any),i2.View_MdIcon_0,
      i2.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,[[2,
      i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(9027584,(null as any),0,i3.MdIcon,[i1.ElementRef,i1.Renderer2,i3.MdIconRegistry],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['search']))],(_ck,_v) => {
    _ck(_v,2,0);
  },(_ck,_v) => {
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
  });
}
export function View_TdSearchBoxComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{_searchInput:0}),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),17,'div',[['class','td-search-box'],['layout','row'],['layout-align',
          'end center']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          10,'button',[['class','td-search-icon mat-icon-button'],['flex','none'],
              ['md-icon-button',''],['type','button']],[[8,'disabled',0]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i4.TdSearchBoxComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.searchClicked()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i3.MdButton,
          [i1.ElementRef,i1.Renderer2,i3.Platform,i3.FocusOriginMonitor],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i3.MdIconButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(0,['\n    '])),
      (_l()(),i1.ɵand(16777216,(null as any),0,1,(null as any),View_TdSearchBoxComponent_1)),
      i1.ɵdid(16384,(null as any),0,i5.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted(0,['\n    '])),(_l()(),i1.ɵand(16777216,
          (null as any),0,1,(null as any),View_TdSearchBoxComponent_2)),i1.ɵdid(16384,
          (null as any),0,i5.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(0,['\n  '])),(_l()(),i1.ɵted((null as any),
          ['\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'td-search-input',
          ([] as any[]),[[24,'@inputState',0]],[[(null as any),'searchDebounce'],[(null as any),
              'search'],[(null as any),'clear']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i4.TdSearchBoxComponent = _v.component;
            if (('searchDebounce' === en)) {
              const pd_0:any = ((<any>_co.handleSearchDebounce($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('search' === en)) {
              const pd_1:any = ((<any>_co.handleSearch($event)) !== false);
              ad = (pd_1 && ad);
            }
            if (('clear' === en)) {
              _co.handleClear();
              const pd_2:any = ((<any>_co.toggleVisibility()) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },i6.View_TdSearchInputComponent_0,i6.RenderType_TdSearchInputComponent)),
      i1.ɵdid(114688,[[1,4],['searchInput',4]],0,i7.TdSearchInputComponent,[[2,i3.Dir]],
          {showUnderline:[0,'showUnderline'],debounce:[1,'debounce'],placeholder:[2,
              'placeholder']},{onSearchDebounce:'searchDebounce',onSearch:'search',
              onClear:'clear'}),(_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵted((null as any),
          ['\n']))],(_ck,_v) => {
    var _co:i4.TdSearchBoxComponent = _v.component;
    const currVal_1:any = (_co.searchVisible && !_co.alwaysVisible);
    _ck(_v,9,0,currVal_1);
    const currVal_2:boolean = (!_co.searchVisible || _co.alwaysVisible);
    _ck(_v,12,0,currVal_2);
    const currVal_4:any = _co.showUnderline;
    const currVal_5:any = _co.debounce;
    const currVal_6:any = _co.placeholder;
    _ck(_v,16,0,currVal_4,currVal_5,currVal_6);
  },(_ck,_v) => {
    var _co:i4.TdSearchBoxComponent = _v.component;
    const currVal_0:any = (i1.ɵnov(_v,5).disabled || (null as any));
    _ck(_v,3,0,currVal_0);
    const currVal_3:any = (_co.alwaysVisible || _co.searchVisible);
    _ck(_v,15,0,currVal_3);
  });
}
export function View_TdSearchBoxComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'td-search-box',
      ([] as any[]),(null as any),(null as any),(null as any),View_TdSearchBoxComponent_0,
      RenderType_TdSearchBoxComponent)),i1.ɵdid(49152,(null as any),0,i4.TdSearchBoxComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const TdSearchBoxComponentNgFactory:i1.ComponentFactory<i4.TdSearchBoxComponent> = i1.ɵccf('td-search-box',
    i4.TdSearchBoxComponent,View_TdSearchBoxComponent_Host_0,{backIcon:'backIcon',
        showUnderline:'showUnderline',debounce:'debounce',alwaysVisible:'alwaysVisible',
        placeholder:'placeholder'},{onSearchDebounce:'searchDebounce',onSearch:'search',
        onClear:'clear'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/~/@covalent/core/search/search-box/search-box.component.ngfactory.ts